import { Component, Input } from '@angular/core';
import { cloneDeep } from 'lodash-es';
import { DataService } from 'src/app/services/data.service';
import { Food } from 'src/interfaces/food.model';
import { MatDialog } from '@angular/material/dialog';
import { MenuFoodDialogComponent } from '../menu-food-dialog/menu-food-dialog.component';
import { sheetDialogConfig } from 'src/app/directives/sheet.directive';
import { BasketService } from 'src/app/services/basket.service';
import { Modificators } from 'src/interfaces/modificators.model';
import { LocalizationService } from 'src/app/services/localization.service';
import { ImageCacheService } from 'src/app/services/image-cache.service';
import { Locale } from 'src/interfaces/locale.model';
import { NO_PHOTO } from 'src/app/utils/no-photo';

@Component({
    selector: 'app-basket-food-card',
    templateUrl: './menu-basket-food-card.component.html',
    styleUrls: ['./menu-basket-food-card.component.css'],
    standalone: false
})
export class MenuBasketFoodCardComponent {

  constructor(
    private dataService: DataService,
    private basketService: BasketService,
    private localization: LocalizationService,
    private imageCache: ImageCacheService,
    private dialog: MatDialog
  ) {
    this.locale = this.dataService.locale;
  }

  locale: Locale | null = null;

  @Input() food: Food | null = null;
  @Input() isLast: boolean = false;

  // Вариант
  variant: string | null = null;
  // Модификаторы
  modificators: Modificators | undefined = undefined;

  // Изображение заглушка
  imageSrc: string = NO_PHOTO.food;

  ngOnInit(): void {
    if (this.food) {
      // Цена блюда
      if (this.food.variability && this.food.variants.length > this.food.choise) {
        console.log('MenuBasketFoodCard | ngOnInit() | choise:', this.food.choise, ' | count:', this.food.count, ' | price:', this.food.totalPrice);
        
        // Вариант блюда
        this.variant = this.food.variants[this.food.choise].title;
      }

      // Image
      if (this.food?.image?.trim()) {
        this.imageCache.getImage(this.food.image, NO_PHOTO.food).then(src => {
          this.imageSrc = src;
        });
      }

      this.modificators = typeof this.food.modificators === 'object' ? this.food.modificators : undefined;
      this.modificators = this.modificators?.items?.length ? this.modificators : undefined;
      this.modificators = this.modificators?.items.some((modificator) => modificator.count > 0) ? this.modificators : undefined;
    }
  }

  increment(): void {
    if (!this.food) return;
    this.food.count++;
    this.basketService.updateFoodInBasket(this.food);
  }

  decrement(): void {
    if (!this.food) return;
    if (this.food.count > 1) {
      this.food.count--;
      this.basketService.updateFoodInBasket(this.food);
    } else {
      this.basketService.removeFoodFromBasket(this.food);
    }
  }

  onFoodClicked(): void {
    this.dialog.open(MenuFoodDialogComponent, sheetDialogConfig(cloneDeep(this.food)));
  }

  get localSize(): string {
    return this.food?.size ? this.food?.size.toLocaleString('ru-RU', { useGrouping: true }) : '';
  }
}
